module.exports = __webpack_public_path__ + "890e7efe7eadfa8f575a2b6bad37a510.svg";